export default __webpack_public_path__ + "static/media/about-us.a75cc5a2.jpg";